import {cookieUtils} from "@utilities/cookie-utils/cookie-utils";
import {shopUtilities} from "@global/shop-utilities/shop-utilities";

const ProductCombotMixin = {
    data() {
        return {
            productComboCookieValue: cookieUtils.getCookie(`productCombo_${window.market}`),
            addedProductCombos: []
        }
    },
    methods: {
        isInProductCombo: function(order_pid) {
            return cookieUtils.isValueInKey(`productCombo_${window.market}`, order_pid) || this.addedProductCombos.indexOf(order_pid) !== -1
        },
        addToProductCombo(order_pid) {
            if(!this.isInProductCombo(order_pid)) {
                this.addedProductCombos.push(order_pid);

                shopUtilities.add('productCombo', order_pid, {});
            }
        },
        removeFromProductCombo(order_pid) {
            if(this.isInProductCombo(order_pid)) {
                this.addedProductCombos.splice(this.addedProductCombos.indexOf(order_pid), 1);
                shopUtilities.remove('productCombo', order_pid, {});
            }
        }
    }
};

export default ProductCombotMixin;
